import { V2ARecipientsConnection } from '@varo/graphql-schema-types';
import {
  AllRecipients,
  getRecipientList,
} from 'features/v2a/sender/helpers/Sender.helpers';
import { useEffect, useState } from 'react';
import QueryV2ARecipients from 'services/graphql/queries/MoveMoney/V2ARecipients';
import { useQuery } from 'urql';

const useRecipients = () => {
  const [topRecipients, setRecipients] = useState<AllRecipients[]>();
  const [
    {
      data: V2ARecipientsData,
      error: V2ARecipientsError,
      fetching: V2ARecipientsLoading,
    },
  ] = useQuery<{
    v2aRecipients: V2ARecipientsConnection;
  }>({
    query: QueryV2ARecipients,
    requestPolicy: 'network-only',
  });

  useEffect(() => {
    if (V2ARecipientsData && !V2ARecipientsError && !V2ARecipientsLoading) {
      const recipients = getRecipientList(V2ARecipientsData.v2aRecipients);
      setRecipients(recipients);
    }
  }, [V2ARecipientsData, V2ARecipientsError, V2ARecipientsLoading]);
  return {
    recipients: topRecipients,
    V2ARecipientsError,
    V2ARecipientsLoading,
  };
};

export default useRecipients;
